import * as React from 'react';
import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={11} height={11} fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_11249_9975)">
      <path
        d="M5.69866 9.55845C8.16422 9.55845 10.1629 7.55973 10.1629 5.09417C10.1629 2.62861 8.16422 0.629883 5.69866 0.629883C3.2331 0.629883 1.23438 2.62861 1.23438 5.09417C1.23438 7.55973 3.2331 9.55845 5.69866 9.55845Z"
        fill="white"
        stroke="#999999"
      />
      <path
        d="M5.69531 3.31641V5.10212L6.76674 6.17355"
        stroke="#999999"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_11249_9975">
        <rect width="10" height="10" fill="white" transform="translate(0.695312 0.09375)" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const IconGrayClock = memo(ForwardRef);
export default IconGrayClock;
